import React, { useEffect, useState, useRef } from 'react';
import { InputAdornment, IconButton, Box, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Form from 'global/components/form';
import { useStyles } from './styles';

export const Language = {
  sp: 'Spanish',
  fr: 'French',
  de: 'German',
  zh: 'Chinese',
  ar: 'Arabic',
  ru: 'Russian',
  ko: 'Korean',
};

const TranslationManager = (props) => {
  const { isEditMode, modifiedLanguageData, setModifiedLanguageData } = props;
  const [availableLanguages, setAvailableLanguages] = useState(Object.keys(Language));

  const styles = useStyles();

  useEffect(() => {
    setAvailableLanguages(Object.keys(Language).filter((lang) => !(lang in modifiedLanguageData)));
  }, [modifiedLanguageData]);

  const handleDeleteTranslation = (lang) => {
    setModifiedLanguageData((prevData) => {
      const newData = { ...prevData };
      delete newData[lang];
      return newData;
    });

    setAvailableLanguages((langs) => [...langs, lang]);
  };

  const handleLanguageSelected = (e) => {
    const selectedLanguage = e.target.value;

    setAvailableLanguages((langs) => langs.filter((lang) => lang !== selectedLanguage));

    setModifiedLanguageData((prevData) => ({
      ...prevData,
      [selectedLanguage]: '',
    }));
  };

  const handleTranslationTextChange = (lang, value) => {
    setModifiedLanguageData((prevData) => ({
      ...prevData,
      [lang]: value,
    }));
  };

  return (
    <Box className={styles.container}>
      <Form
        showNavigation={false}
        screens={[
          {
            inputs: [
              ...(Object.entries(modifiedLanguageData).length > 0 ? 
              [{
                id: 'translationManager',
                style: { paddingTop: 0, marginBottom: 0 },
                component: () => (
                  <>
                    {Object.entries(modifiedLanguageData).map(([lang, desc]) => (
                      <TextField
                        key={lang}
                        className={styles.topBottomSpacing}
                        label={Language[lang]}
                        disabled={!isEditMode}
                        variant={isEditMode ? 'outlined' : 'standard'}
                        onChange={(e) => handleTranslationTextChange(lang, e.target.value)}
                        multiline
                        fullWidth
                        placeholder="Enter translation here..."
                        value={desc}
                        InputProps={
                          isEditMode
                            ? {
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <IconButton className={styles.cancelIcon} onClick={() => handleDeleteTranslation(lang)}>
                                      <CloseIcon />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }
                            : undefined
                        }
                      />
                    ))}
                  </>
                ),
              }] : []),
              ...(isEditMode
                ? [
                    {
                      id: 'addNewTranslation',
                      type: 'Select',
                      data: availableLanguages.map((langCode) => ({
                        value: langCode,
                        title: Language[langCode],
                      })),
                      props: {
                        label: 'Add New Language',
                        onChange: handleLanguageSelected,
                        disabled: !isEditMode,
                      },
                    },
                  ]
                : []),
            ],
          },
        ]}
      />
    </Box>
  );
};

export default TranslationManager;
